import payoutsServices from "../Services/payoutsServices";
import { showToast } from "./toast";
import { GET_PAYOUT, GET_PAYOUTS } from "./type";
import { startLoaderAction, stopLoaderAction } from "./updateReducerValue";

export const getPayoutsAction = (page, limit, status) => async (dispatch) => {
  dispatch(startLoaderAction());
  return payoutsServices.getPayouts(page, limit, status).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_PAYOUTS, payload: resp.data });
    } else {
      //   dispatch(showToast(resp?.data, "error"));
    }
    dispatch(stopLoaderAction());
  });
};

export const payProviderAction = (id, amount) => (dispatch) => {
  dispatch(startLoaderAction());
  return payoutsServices.payProvider(id, amount).then((resp) => {
    if (resp.status) {
      dispatch(showToast(resp?.data, "success"));
      dispatch(stopLoaderAction());
    } else {
      dispatch(showToast(resp?.data, "error"));
      dispatch(stopLoaderAction());
    }
    return Promise.resolve();
  });
};

export const getPayoutAction = (id) => async (dispatch) => {
  dispatch(startLoaderAction());
  return payoutsServices.getPayout(id).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_PAYOUT, payload: resp.data });
    } else {
      //   dispatch(showToast(resp?.data, "error"));
    }
    dispatch(stopLoaderAction());
  });
};